import React from 'react';
import '../App.css';

function RGPD() {
  return (
    <div className="content">
      <h1 className="title">Politique de confidentialité</h1>
      <p className="description">
        Cette politique de confidentialité décrit comment nous recueillons, utilisons et partageons vos informations lorsque vous utilisez notre application.
      </p>
      <h2 className="subtitle">Collecte d'informations</h2>
      <p className="description">
        Lorsque vous utilisez notre application, nous pouvons collecter des informations vous concernant, telles que votre nom, votre adresse e-mail et des informations sur votre utilisation de l'application.
      </p>
      <h2 className="subtitle">Utilisation des informations</h2>
      <p className="description">
        Nous utilisons les informations que nous collectons pour améliorer notre application et pour vous fournir un meilleur service. Nous ne vendrons ni ne louerons vos informations à des tiers.
      </p>
      <h2 className="subtitle">Partage des informations</h2>
      <p className="description">
        Nous pouvons partager vos informations avec des prestataires de services tiers qui nous aident à fournir notre application. Nous pouvons également divulguer vos informations si la loi l'exige ou si cela est nécessaire pour protéger nos droits ou ceux d'autrui.
      </p>
      <h2 className="subtitle">Sécurité des informations</h2>
      <p className="description">
        Nous prenons des mesures raisonnables pour protéger les informations que nous collectons contre la perte, l'utilisation abusive et l'accès non autorisé, la divulgation, l'altération et la destruction.
      </p>
      <h2 className="subtitle">Modification de la politique de confidentialité</h2>
      <p className="description">
        Nous pouvons modifier cette politique de confidentialité à tout moment. Si nous apportons des modifications importantes, nous vous en informerons en affichant un avis sur notre site web ou en vous envoyant un e-mail.
      </p>
    </div>
  );
}

export default RGPD;
